module.exports = __webpack_public_path__ + "img/m-banner-1m.acb492ba.png";